export enum FileStatus {
    verified = 'verified',
    pending_verification = 'pending_verification',
    verification_failed = 'verification_failed',
}
